/** @format */
/** @format */

import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { _$, Button, Card, Icon, Switch } from '@king-design/react'
import { MonitorCrumb, DescriptionItem, Descriptions } from 'src/components'
import { useHistory, useLocation } from 'react-router'
import { getPrometheusAlertTemplate } from 'src/api/ApiPrometheusAlarm'
import { useAsync } from 'react-use'
import variable from 'src/static/styles/var'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const AlarmViewPage: FC<{ className?: string }> = ({ className }) => {
  const history = useHistory()
  const query = useQuery()
  const ruleid = query.get('ruleid')
  const templateid = query.get('templateid')
  const tab = query.get('tab')
  const [expands, setExpands] = useState<number[]>([])
  // 初始化
  const { value: result } = useAsync(async () => {
    if (templateid) {
      const result = await getPrometheusAlertTemplate({
        TemplateID: parseInt(templateid)
      })
      if (result?.AlertTemplate) {
        const { Rules } = result.AlertTemplate
        setExpands(ruleid ? [parseInt(ruleid)] : Rules?.map(item => item.RuleID))
        return {
          Name: result.AlertTemplate.Name,
          Rules: result.AlertTemplate.Rules || []
        }
      }
    }
  }, [ruleid, templateid])

  return (
    <div className={className}>
      <MonitorCrumb
        breadArr={[
          { title: _$('Prometheus监控'), route: '/monitor/prometheusmonitor/alarm' },
          {
            title: _$('告警管理'),
            route: `/monitor/prometheusmonitor/alarm?${tab ? `tab=${tab}` : ''}`
          },
          { title: _$('模板详情') }
        ]}
      />
      <Card>
        <Descriptions columns={1}>
          <DescriptionItem label={_$('模板名称')}>{result?.Name || '-'}</DescriptionItem>
          <DescriptionItem label={_$('告警规则')}>
            {result?.Rules?.length > 1 ? (
              <div className="all_expand">
                <Switch
                  on={_$('全部收起')}
                  off={_$('全部展开')}
                  width="82"
                  height="22"
                  value={expands?.length === result?.Rules?.length}
                  onChangeValue={value => {
                    setExpands(value ? result?.Rules?.map(rule => rule.RuleID) : [])
                  }}
                />
              </div>
            ) : null}
            {result?.Rules?.map((rule, index) => {
              const { RuleID, Alert, Expr, For, Labels, Annotations } = rule
              return (
                <div key={RuleID} className="rule_item">
                  {expands?.includes(RuleID) ? (
                    <div className="rule_item_container">
                      <Icon
                        className="k-icon-up"
                        size={16}
                        onClick={() => {
                          setExpands(expands?.filter(id => id !== rule.RuleID))
                        }}
                      />
                      <Descriptions columns={1}>
                        <DescriptionItem label={_$('规则名称')}>{Alert}</DescriptionItem>
                        <DescriptionItem label={_$('规则表达式')}>{Expr}</DescriptionItem>
                        <DescriptionItem label={_$('持续时间')}>{For}</DescriptionItem>
                        <DescriptionItem label={_$('标签')}>
                          {Labels?.map(({ Name, Value }) => (
                            <div className="label_item" key={Name}>
                              <p className="label_item_name">{Name}</p>
                              <p className="label_item_value">{Value}</p>
                            </div>
                          )) || '-'}
                        </DescriptionItem>
                        <DescriptionItem label={_$('注解')}>
                          {Annotations?.map(({ Name, Value }) => (
                            <div className="label_item" key={Name}>
                              <p className="label_item_name">{Name}</p>
                              <p className="label_item_value">{Value}</p>
                            </div>
                          )) || '-'}
                        </DescriptionItem>
                      </Descriptions>
                    </div>
                  ) : (
                    <div className="rule_item_header">
                      <p>
                        <i style={{ marginRight: 8 }}>#{index + 1}.</i>
                        <span>{Alert}</span>
                      </p>
                      <div className="ksc-space">
                        <Icon
                          className="k-icon-down"
                          size={16}
                          onClick={() => {
                            setExpands([...expands, RuleID])
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </DescriptionItem>
        </Descriptions>
      </Card>
      <div className="bottom_action">
        <Button
          onClick={() => {
            history.goBack()
          }}
          type="default"
        >
          {_$('取消')}
        </Button>
      </div>
    </div>
  )
}

export default styled(AlarmViewPage)`
  position: relative;
  padding-bottom: 80px;
  .k-card {
    padding: 16px 0;
    .k-card-body {
      height: calc(100vh - 212px);
      overflow-y: auto;
      padding-bottom: 0;
      padding-top: 0;
      .k-descriptions-content {
        padding-top: 0;
        /* width: ; */
      }
      .k-description-item {
        align-items: flex-start;
        .all_expand {
          margin-bottom: 16px;
        }
        p {
          margin-bottom: 0;
        }
        .k-icon {
          cursor: pointer;
          line-height: 32px;
          transition: all ease-in-out 0.3s;
          &:hover {
            color: ${variable.primaryColor};
          }
        }
        .rule_item {
          width: 700px;
          margin-bottom: 16px;
          .rule_item_header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 32px;
            line-height: 32px;
            padding: 0 16px;
            transition: all 0.3s;
            background-color: #f0f2f4;
            &:hover {
              background-color: #dedede;
            }
          }
          .rule_item_container {
            position: relative;
            width: 100%;
            padding: 8px 16px;
            border: 1px solid #e2e5e8;
            background-color: #f0f2f4;
            .k-description-item-label {
              width: 80px;
              justify-content: flex-end;
            }
            .k-description-centent {
              width: 550px;
              max-width: 100%;
            }
            .label_item {
              display: flex;
              margin-bottom: 6px;
              p.label_item_name {
                max-width: 100px;
                margin-bottom: 0;
                word-break: break-all;
                overflow-wrap: break-word;
                white-space: pre-wrap;
                margin-right: 8px;
                font-weight: 600;
                text-align: right;
              }
              p.label_item_value {
                flex: 1;
                word-break: break-all;
                overflow-wrap: break-word;
                white-space: pre-line;
              }
            }
            .k-icon-up {
              position: absolute;
              top: 16px;
              right: 16px;
            }
          }
        }
      }
    }
  }
  .bottom_action {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 64px;
    padding: 16px 0;
    background: #ffffff;
    border-top: 1px solid #f0f0f0;
    border-left: 1px solid #f0f0f0;
    padding-right: 16px;
    z-index: 98;
    box-shadow: rgba(0, 0, 0, 0.04) 0px 0px 5px;
    border-radius: 6px 6px 0 0;
    button {
      font-size: 14px;
      margin-left: 8px;
    }
  }
`
